<template>
  <div id="bod-archives">bod archives</div>
</template>

<script>
import store from "../../store";
export default {
  beforeRouteEnter(to, from, next) {
    const currentUser = store.state.auth.user;
    console.log(currentUser);
    if (currentUser && !currentUser.permissions.includes("Director")) {
      console.log(":401");
      next({ name: "notfound404" });
    } else {
      next();
    }
  },
};
</script>

<style></style>
